export default __webpack_public_path__ + "static/media/101Nights400.53f2338c.jpg";